import React from "react";
import DatePicker from "../../common/input/DatePicker";
import InputCell from "./InputCell";

const DateInputCell = ({name}) => <InputCell text='Дата' component={DatePicker} name={name} />;

export default DateInputCell;